import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import {Button, Card, Col, Row, Table} from "react-bootstrap";

function MemberPage() {
    return (
        <>
            <Navbar/>
            <Card>
                <Card.Header>Mitglied werden</Card.Header>
                <Card.Body>
                    <Card.Text style={{whiteSpace: 'pre-line'}}>
                        Möchtest du die faszinierende Erfahrung des Tauchens einmal erleben oder hast du bereits
                        Erfahrung und suchst Tauchfreunde?

                        Dann komm zum Schnuppertauchen / Probetraining vorbei und lerne uns kennen. Nach 4 kostenlosen
                        Probetrainings kannst du entscheiden, ob du bei uns Mitglied werden möchtest.

                        Kinder sollten mindestens 8 Jahre alt sein und sicher die Schwimmstile Brustschwimmen und
                        Kraulen beherrschen. Es sollte keine bekannten Probleme mit den Ohren oder der Nase bzw. den
                        Nebenhöhlen bestehen.

                        Um Mitglied zu werden, komm gern einmal zu unseren Trainingszeiten in das <a href="https://www.stadtbad-hennigsdorf.de" target="_blank" rel="noopener noreferrer">Stadtbad Hennigsdorf</a>.
                        Damit wir für dich auch Zeit haben, wäre es schön, wenn du dich unter <a href="mailto:vorstand@stahl-taucher.de">vorstand@stahl-taucher.de</a> oder über das <a href="/kontakt">Kontaktformular</a> anmeldest.
                            
                        Das Kostet eine Mitgliedschaft in unserem Verein:
                    </Card.Text>

                    <Table bordered hover responsive>
                        <thead>
                        <tr>
                            <th>Beitrag</th>
                            <th>pro Monat</th>
                            <th>Gesamt pro Jahr</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Jugendmitglied bis 18 Jahre</td>
                            <td>12,50 €</td>
                            <td>150,00 €</td>
                        </tr>
                        <tr>
                            <td>Erwachsener (Vollmitglied)</td>
                            <td>16,00 €</td>
                            <td>192,00 €</td>
                        </tr>
                        <tr>
                            <td>Familienmitglied und ermäßigt</td>
                            <td>12,50 €</td>
                            <td>150,00 €</td>
                        </tr>
                        <tr>
                            <td>Ruhende Mitgliedschaft</td>
                            <td>8,00 €</td>
                            <td>96,00 €</td>
                        </tr>
                        <tr>
                            <td>Einmalige Aufnahmegebühr<br/>(nicht bei Kindern und Jugendlichen unter 18 Jahren)</td>
                            <td>1/2 Jahresbeitrag</td>
                            <td>96,00 €</td>
                        </tr>
                        </tbody>
                    </Table>

                    <Card.Text style={{whiteSpace: 'pre-line'}}>
                        Das benötigst du um Mitglied zu werden:

                        Wenn Du zum Probetraining kommen möchtet, bringe bitte möglichst das <a href="pdfs/Versicherungsschutz_vor_Vereinsaufnahme.pdf" target="_blank" rel="noopener noreferrer">Formular für den vorläufigen Versicherungsschutz</a> ausgefüllt mit.

                        Wenn du Mitglied werden möchtest, benötigen wir von dir den <a href="pdfs/Aufnahmeantrag.pdf" target="_blank" rel="noopener noreferrer">ausgefüllten Aufnahmeantrag</a> (inkl. Datenschutzerklärung und SEPA-Lastschrifteinzugsermächtigung).

                        Für die Ausbildung zum einem der Taucherbrevets benötigst du eine gültige
                        Tauchtauglichkeitsuntersuchung. Alle Infos dazu findest du <a href="/medizin">hier</a>.
                        <br/>
                        <br/>
                        <Row>
                            <Col xs={12} md={6}>
                                <div><strong>Vereinskonto</strong></div>
                                <div>Tauchsportclub Stahl Hennigsdorf e.V.</div>
                                <div>Mittelbrandenburgische Sparkasse</div>
                                <div>IBAN: DE43 1605 0000 1000 0465 98</div>
                                <div>BIC: WELADED1PMB</div>
                            </Col>
                        </Row>

                    </Card.Text>
                </Card.Body>
            </Card>

            <Card className="impressum">
                <Button variant="Link" href="/impressum">Impressum</Button>
            </Card>
        </>
    );
}

export default MemberPage;
